import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type NotificationType = 'success' | 'error' | 'info' | 'warning';

export interface NotificationAction {
  label: string;
  fn: () => void;
}

export interface NotificationMessage {
  id: number;
  type: NotificationType;
  message: string;
  duration?: number;
  action?: NotificationAction;
}

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private messagesSubject = new BehaviorSubject<NotificationMessage[]>([]);
  messages$ = this.messagesSubject.asObservable();
  private counter = 0;

  notify(type: NotificationType, message: string, options?: { duration?: number; action?: NotificationAction }): void {
    const id = ++this.counter;
    const duration = options?.duration ?? 5000;
    const entry: NotificationMessage = { id, type, message, duration, action: options?.action };
    this.messagesSubject.next([...this.messagesSubject.value, entry]);
    if (duration > 0) {
      setTimeout(() => this.dismiss(id), duration);
    }
  }

  dismiss(id: number): void {
    const next = this.messagesSubject.value.filter(message => message.id !== id);
    this.messagesSubject.next(next);
  }
}
